import {useEffect, useState} from "react";
import {Button, Grid, IconButton, Stack} from "@mui/material";
import {EditRounded, Lock} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import { FormProvider } from "react-hook-form";
import {NetworkScope} from "../../../../../types";
import {useHasScope} from "../../../../../../../config/globalConfig";
import { ITabWrapper } from "./types";
import SaveModal from "../../../SaveModal/SaveModal";

const TabWrapper = ({infoForm, children, onSubmit, expanded}: ITabWrapper) => {
    const {t} = useTranslation(["network", "translation"]);
    const hasScope = useHasScope;
    
    const [open, setOpen] = useState(false);
    const [isDisabled, setIsDisabled] = useState<boolean>(true);

    useEffect(() => {expanded(!isDisabled)},[isDisabled]);

    return(
        <FormProvider {...infoForm}>
            <Grid container direction="row" alignItems="start">
                <Grid item xs={12}>
                    <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                        {(hasScope(NetworkScope.MsMng) && isDisabled) &&
                            <IconButton color="accent" onClick={() => setIsDisabled(false)}>
                                <EditRounded/>
                            </IconButton>
                        }
                    </Stack>
                </Grid>
                <Grid container item direction="row" xs={12} columnSpacing={2} padding={1} alignItems="center">
                    {children}
                </Grid>
                <Grid item xs={12}>
                    <Stack direction="column" spacing={2} justifyContent="flex-end" alignItems="flex-end">
                        {!isDisabled &&
                            <Button variant="contained" onClick={() => setOpen(true)} >
                                {t("rsDetail.tabWrapper.button.edit")}
                            </Button>
                        }
                    </Stack>
                </Grid>
            </Grid>
            <SaveModal infoForm={infoForm} onSubmit={onSubmit} openState={[open, setOpen]} setIsDisabled={setIsDisabled} />
        </FormProvider>
    )
}

export default TabWrapper;
